import React from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { FiCheckCircle, FiCalendar } from "react-icons/fi";
import CountUp from 'react-countup';
import TrackVisibility from 'react-on-screen';

const Stat = ({ end }) => (
  <TrackVisibility once>
    {({ isVisible }) => (isVisible ? <CountUp end={end} duration={1} /> : end)}
  </TrackVisibility>
);

const MvpBanner = () => {
  return (
    <div className="section section-padding pb-5 mvp-banner-area position-relative">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-12">
            <div className="mvp-banner-content">
              <AnimationOnScroll
                animateIn="fadeInUp"
                animateOnce={true}
                delay={100}
              >
                <h1 className="title fw-bold" style={{ fontSize: "52px", lineHeight: "1.2" }}>
                  Ship Your <span className="text-primary">MVP</span> <br />
                  in just <span className="text-primary">6-8 weeks</span> <br />
                </h1>

                <p className="subtitle mt-4 mb-5" style={{ fontSize: "18px", color: "var(--color-body)" }}>
                  <strong className="text-dark">From Concept to Investor - Ready - Fast.</strong>
                  <br /><br />
                  We help startups and businesses across industries turn ideas into validated, market-ready products with speed and precision.
                </p>

                <div className="button-group d-flex flex-wrap align-items-center mb-5 gap-3">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      if (window.Calendly) {
                        window.Calendly.initPopupWidget({ url: "https://calendly.com/itcodeinfotech/itcode_infotech_tech_solutions" });
                      } else {
                        window.open("https://calendly.com/itcodeinfotech/itcode_infotech_tech_solutions", "_blank", "noopener,noreferrer");
                      }
                    }}
                    className="axil-btn"
                    style={{
                      padding: "15px 32px",
                      borderRadius: "80px",
                      backgroundColor: "#006bff",
                      color: "#fff",
                      border: "1px solid #006bff",
                      fontWeight: "600",
                      fontSize: "16px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 12px rgba(0, 107, 255, 0.2)"
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = "#0056b3";
                      e.currentTarget.style.borderColor = "#0056b3";
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 107, 255, 0.3)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = "#006bff";
                      e.currentTarget.style.borderColor = "#006bff";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 107, 255, 0.2)";
                    }}
                  >
                    <FiCalendar size={20} /> Schedule a meeting
                  </button>
                </div>

                <ul className="list-unstyled d-flex flex-column gap-3 mt-4 mb-0">
                  <li className="d-flex align-items-baseline text-dark fw-bold" style={{ fontSize: "17px" }}>
                    <FiCheckCircle className="text-primary me-3 flex-shrink-0" size={22} style={{ color: "#006bff" }} />
                    <span>Cost Effective</span>
                  </li>
                  <li className="d-flex align-items-baseline text-dark fw-bold" style={{ fontSize: "17px" }}>
                    <FiCheckCircle className="text-primary me-3 flex-shrink-0" size={22} style={{ color: "#006bff" }} />
                    <span>Scalable</span>
                  </li>
                  <li className="d-flex align-items-baseline text-dark fw-bold" style={{ fontSize: "17px" }}>
                    <FiCheckCircle className="text-primary me-3 flex-shrink-0" size={22} style={{ color: "#006bff" }} />
                    <span>Designed for startups & growing businesses</span>
                  </li>
                </ul>

              </AnimationOnScroll>
            </div>
          </div>
          <div className="col-lg-6 col-12 mt-5 mt-lg-0">
            <div className="mvp-banner-thumbnail text-center">
              <AnimationOnScroll
                animateIn="zoomIn"
                duration={2}
                delay={300}
                animateOnce={true}
              >
                <img
                  src={process.env.PUBLIC_URL + "/images/banner/laptop-poses.png"}
                  alt="MVP Development Illustration"
                  className="img-fluid"
                />
              </AnimationOnScroll>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Stats Area */}
      <div className="container mt-5 floating-stats-container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="mvp-stats-box bg-white p-4 rounded d-flex flex-wrap justify-content-between text-center">
              <div className="stat-item flex-fill p-3">
                <h3 className="text-primary fw-bold mb-1">
                  <Stat end={7} />+
                </h3>
                <p className="mb-0 text-muted">Years of Service</p>
              </div>
              <div className="stat-item flex-fill p-3 border-start">
                <h3 className="text-primary fw-bold mb-1">
                  <Stat end={10} />+
                </h3>
                <p className="mb-0 text-muted">Global Reach</p>
              </div>
              <div className="stat-item flex-fill p-3 border-start">
                <h3 className="text-primary fw-bold mb-1">
                  <Stat end={1000} />+
                </h3>
                <p className="mb-0 text-muted">Our Clients</p>
              </div>
              <div className="stat-item flex-fill p-3 border-start">
                <h3 className="text-primary fw-bold mb-1">
                  <Stat end={110} />+
                </h3>
                <p className="mb-0 text-muted">Projects</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MvpBanner;
